import { DefaultState } from 'store/types';
export const SET_OCCUPANCY_INSIGHTS_TABLE_FILTERS = "SET_OCCUPANCY_INSIGHTS_TABLE_FILTERS";

export type OccupancyInsightsTableFilters = {
  fromDate: Date;
  toDate?: Date;
  dates: string;
  miles: number;
  showAllReservations?: boolean;
}

export type OccupancyInsightsTableFiltersState = DefaultState & {
  contents: OccupancyInsightsTableFilters;
};

interface SetOccupancyInsightsTableFilters {
  type: typeof SET_OCCUPANCY_INSIGHTS_TABLE_FILTERS;
  contents: OccupancyInsightsTableFilters;
}

export type OccupancyInsightsTableFiltersActionTypes = SetOccupancyInsightsTableFilters;
